export const getIsMobile = (): boolean => {
    return matchMedia("(max-width: 700px)").matches;
};

export const scrollDivTo = (domNode: HTMLDivElement, x: number, y: number = 0): void => {
    domNode.scrollTo(x, y);
};
